import React from 'react';
import './DevelopmentServices.css';

function DevelopmentServices() {
  return (
    <div className="development-services-page">
      <div className="development-container">
        <h1 className="development-title">Development Services</h1>
        <p className="development-subtitle">
          Professional web development and software solutions
        </p>

        <div className="dev-services-grid">
          <div className="dev-service-card">
            <div className="dev-service-icon">🌐</div>
            <h3>Web Development</h3>
            <p className="dev-service-description">
              Custom websites and web applications built with modern technologies
            </p>
            <ul className="dev-service-features">
              <li>React.js / Next.js</li>
              <li>Responsive Design</li>
              <li>SEO Optimized</li>
              <li>Performance Optimization</li>
              <li>Cross-browser Compatible</li>
            </ul>
            <div className="dev-service-price">Starting at $500</div>
            <button className="dev-service-btn">Get Quote</button>
          </div>

          <div className="dev-service-card featured">
            <div className="service-badge">Popular</div>
            <div className="dev-service-icon">⚛️</div>
            <h3>React Applications</h3>
            <p className="dev-service-description">
              Full-stack React applications with Node.js backend
            </p>
            <ul className="dev-service-features">
              <li>React.js Frontend</li>
              <li>Node.js / Express Backend</li>
              <li>MongoDB / PostgreSQL</li>
              <li>RESTful APIs</li>
              <li>Real-time Features</li>
            </ul>
            <div className="dev-service-price">Starting at $1,000</div>
            <button className="dev-service-btn">Get Quote</button>
          </div>

          <div className="dev-service-card">
            <div className="dev-service-icon">🤖</div>
            <h3>Discord Bots</h3>
            <p className="dev-service-description">
              Custom Discord bots with advanced features and integrations
            </p>
            <ul className="dev-service-features">
              <li>Slash Commands</li>
              <li>Moderation Tools</li>
              <li>Music Bots</li>
              <li>Economy Systems</li>
              <li>Custom Features</li>
            </ul>
            <div className="dev-service-price">Starting at $200</div>
            <button className="dev-service-btn">Get Quote</button>
          </div>

          <div className="dev-service-card">
            <div className="dev-service-icon">📱</div>
            <h3>Mobile Apps</h3>
            <p className="dev-service-description">
              Cross-platform mobile applications using React Native
            </p>
            <ul className="dev-service-features">
              <li>React Native</li>
              <li>iOS & Android</li>
              <li>Native Features</li>
              <li>App Store Deployment</li>
              <li>Maintenance & Updates</li>
            </ul>
            <div className="dev-service-price">Starting at $2,000</div>
            <button className="dev-service-btn">Get Quote</button>
          </div>

          <div className="dev-service-card">
            <div className="dev-service-icon">🔧</div>
            <h3>API Development</h3>
            <p className="dev-service-description">
              RESTful and GraphQL APIs for your applications
            </p>
            <ul className="dev-service-features">
              <li>RESTful APIs</li>
              <li>GraphQL</li>
              <li>Authentication</li>
              <li>Rate Limiting</li>
              <li>Documentation</li>
            </ul>
            <div className="dev-service-price">Starting at $300</div>
            <button className="dev-service-btn">Get Quote</button>
          </div>

          <div className="dev-service-card">
            <div className="dev-service-icon">🎨</div>
            <h3>UI/UX Design</h3>
            <p className="dev-service-description">
              Beautiful and intuitive user interfaces and experiences
            </p>
            <ul className="dev-service-features">
              <li>Wireframing</li>
              <li>Prototyping</li>
              <li>Design Systems</li>
              <li>User Research</li>
              <li>Responsive Design</li>
            </ul>
            <div className="dev-service-price">Starting at $400</div>
            <button className="dev-service-btn">Get Quote</button>
          </div>
        </div>

        <div className="dev-process">
          <h2>Our Development Process</h2>
          <div className="process-steps">
            <div className="process-step">
              <div className="step-number">1</div>
              <h4>Planning</h4>
              <p>We discuss your requirements and create a detailed project plan</p>
            </div>
            <div className="process-step">
              <div className="step-number">2</div>
              <h4>Design</h4>
              <p>Create wireframes and designs based on your vision</p>
            </div>
            <div className="process-step">
              <div className="step-number">3</div>
              <h4>Development</h4>
              <p>Build your project using best practices and modern technologies</p>
            </div>
            <div className="process-step">
              <div className="step-number">4</div>
              <h4>Testing</h4>
              <p>Thorough testing to ensure quality and functionality</p>
            </div>
            <div className="process-step">
              <div className="step-number">5</div>
              <h4>Deployment</h4>
              <p>Deploy your project and provide ongoing support</p>
            </div>
          </div>
        </div>

        <div className="dev-technologies">
          <h2>Technologies We Use</h2>
          <div className="tech-list">
            <div className="tech-item">React.js</div>
            <div className="tech-item">Node.js</div>
            <div className="tech-item">Express</div>
            <div className="tech-item">MongoDB</div>
            <div className="tech-item">PostgreSQL</div>
            <div className="tech-item">TypeScript</div>
            <div className="tech-item">Next.js</div>
            <div className="tech-item">React Native</div>
            <div className="tech-item">GraphQL</div>
            <div className="tech-item">Docker</div>
            <div className="tech-item">AWS</div>
            <div className="tech-item">Firebase</div>
          </div>
        </div>

        <div className="contact-section">
          <h2>Ready to Start Your Project?</h2>
          <p>Contact us for a free consultation and quote</p>
          <a 
            href="https://discord.gg/RXVZZWzMcq" 
            target="_blank" 
            rel="noopener noreferrer"
            className="contact-btn"
          >
            Contact Us on Discord
          </a>
        </div>
      </div>
    </div>
  );
}

export default DevelopmentServices;

